import React, { useState, useEffect } from 'react';
import SuperAdminLayout from '../components/SuperAdminLayout';

const SuperAdminAnalytics = () => {
  const [analytics, setAnalytics] = useState({});

  useEffect(() => {
    const mockAnalytics = {
      totalBookings: 1250,
      totalRevenue: 187500,
      averageBookingValue: 150
    };
    setAnalytics(mockAnalytics);
  }, []);

  return (
    <SuperAdminLayout>
      <header style={{
        background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 50%, #10b981 100%)',
        color: 'white',
        padding: '16px 20px',
        boxShadow: '0 4px 15px rgba(6, 182, 212, 0.2)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: '700', margin: '0 0 4px 0' }}>Analytics</h1>
            <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0, fontSize: '0.85rem' }}>Performance insights</p>
          </div>
          <div style={{
            background: 'rgba(255,255,255,0.2)',
            padding: '6px 12px',
            borderRadius: '8px',
            fontSize: '0.8rem',
            fontWeight: '600'
          }}>
            Real-time
          </div>
        </div>
      </header>

      <main style={{ padding: '16px', overflow: 'auto' }}>
        <div style={{ display: 'grid', gap: '16px' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px'
          }}>
            {[
              { icon: '📊', title: 'Bookings', value: analytics.totalBookings || 0, color: '#06b6d4' },
              { icon: '💰', title: 'Revenue', value: `₹${(analytics.totalRevenue || 0).toLocaleString()}`, color: '#10b981' },
              { icon: '📈', title: 'Avg Value', value: `₹${Math.round(analytics.averageBookingValue || 0)}`, color: '#0891b2' }
            ].map((stat, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 4px 15px rgba(6, 182, 212, 0.1)',
                border: '1px solid rgba(6, 182, 212, 0.1)',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  margin: '0 auto 8px',
                  borderRadius: '10px',
                  background: stat.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.2rem'
                }}>
                  {stat.icon}
                </div>
                <h3 style={{ fontSize: '0.8rem', fontWeight: '600', color: '#64748b', margin: '0 0 4px 0', textTransform: 'uppercase' }}>{stat.title}</h3>
                <p style={{ fontSize: '1.3rem', fontWeight: '700', color: '#1e293b', margin: 0 }}>{stat.value}</p>
              </div>
            ))}
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1fr 1fr',
            gap: '16px'
          }}>
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 4px 15px rgba(6, 182, 212, 0.1)',
              border: '1px solid rgba(6, 182, 212, 0.1)'
            }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1e293b', marginBottom: '12px' }}>Monthly Trends</h3>
              <div style={{ height: '120px', display: 'flex', alignItems: 'end', justifyContent: 'space-between', gap: '2px' }}>
                {[45, 67, 89, 56, 78, 92, 73, 85, 94, 67, 81, 96].map((height, index) => (
                  <div key={index} style={{
                    flex: 1,
                    background: 'linear-gradient(to top, #06b6d4, #10b981)',
                    borderRadius: '2px 2px 0 0',
                    height: `${height}%`,
                    opacity: 0.8
                  }}></div>
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#64748b', marginTop: '8px' }}>
                <span>Jan</span><span>Feb</span><span>Mar</span><span>Apr</span><span>May</span><span>Jun</span>
                <span>Jul</span><span>Aug</span><span>Sep</span><span>Oct</span><span>Nov</span><span>Dec</span>
              </div>
            </div>

            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 4px 15px rgba(6, 182, 212, 0.1)',
              border: '1px solid rgba(6, 182, 212, 0.1)'
            }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#1e293b', marginBottom: '12px' }}>Top Cities</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[
                  { city: 'Bhubaneswar', bookings: 450, revenue: 67500, growth: 23 },
                  { city: 'Cuttack', bookings: 320, revenue: 48000, growth: 18 },
                  { city: 'Puri', bookings: 280, revenue: 42000, growth: 15 },
                  { city: 'Berhampur', bookings: 200, revenue: 30000, growth: 12 }
                ].map((city, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px',
                    background: '#f8fafc',
                    borderRadius: '8px'
                  }}>
                    <div>
                      <p style={{ fontWeight: '600', color: '#1e293b', margin: 0, fontSize: '0.85rem' }}>{city.city}</p>
                      <p style={{ fontSize: '0.7rem', color: '#64748b', margin: 0 }}>{city.bookings} bookings • ₹{city.revenue.toLocaleString()}</p>
                    </div>
                    <span style={{
                      fontSize: '0.7rem',
                      fontWeight: '600',
                      color: '#166534',
                      background: '#dcfce7',
                      padding: '2px 6px',
                      borderRadius: '10px'
                    }}>
                      +{city.growth}%
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </SuperAdminLayout>
  );
};

export default SuperAdminAnalytics;